import { put, call, takeEvery } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import { replace } from "react-router-redux";
import axios from "axios";

import { logoutRequest } from "../../login/actions";

import {
  UPDATE_PLAYLIST_REQUEST,
  updatePlaylistSuccess,
  updatePlaylistError,
} from "./actions";
import { Env } from "../../../env";

function* updatePlaylistRequest(action) {
  const { userId, playlistId, accessToken, values, videos } = action;
  let response;

  try {
    response = yield call(
      axios.put,
      `${Env.BASE_API_URL}/Accounts/${userId}/Playlists/${playlistId}`,
      {
        ...values,
        videos,
      },
      {
        headers: { Authorization: accessToken },
      }
    );
  } catch (err) {
    if (err.response && err.response.status === 400) {
      yield put(updatePlaylistError());
      yield put(flashMessage("Erreur, veuillez vérifier vos informations."));
    } else if (err.response && err.response.status === 404) {
      yield put(updatePlaylistError());
      yield put(flashMessage("Erreur, cette playlist n'existe pas."));
    } else if (err.response && err.response.status === 401) {
      yield put(logoutRequest());
    } else {
      yield put(updatePlaylistError());
      yield put(flashMessage("Une erreur s'est produite, veuillez réessayer."));
    }

    return;
  }

  yield put(updatePlaylistSuccess(response.data));

  yield put(flashMessage("La playlist a été éditée avec succès."));

  yield put(replace("/playlists"));
}

export default function* watchUpdatePlaylistRequest() {
  yield takeEvery(UPDATE_PLAYLIST_REQUEST, updatePlaylistRequest);
}



// WEBPACK FOOTER //
// ./src/pages/playlists/update/saga.js